import React, { useEffect, useState } from "react";
import DatePicker from "react-multi-date-picker";
import axios from "axios";
import { apiKey } from "../config/config";
import Table from "../components/Table";

function DetailedOperationalReport({ lang }) {
  const token = JSON.parse(sessionStorage.getItem("aman-admin") || "null")
    ?.admin
    ? JSON.parse(JSON.parse(sessionStorage.getItem("aman-admin")).admin).token
    : null;

  const [reports, setReports] = useState([]);
  const [investorList, setInvestorList] = useState([]);
  const [investor, setInvestor] = useState("");
  const [branchId, setBranchId] = useState();
  const [from, setFrom] = useState();
  const [to, setTo] = useState();

  function convertDateFormat(inputDate) {
    const dateObject = new Date(inputDate);
    const options = { day: "2-digit", month: "2-digit", year: "numeric" };
    const locale = lang.Lang === "en" ? "en-US" : "ar-SA";

    const formattedDate = dateObject.toLocaleDateString(locale, options);
    return formattedDate;
  }

  const columns = [
    {
      header: lang.SN || "SN",
      cell: (row) => row.row.index + 1,
    },
    {
      header: lang.Investor || "Investor",
      accessorKey: "investorName",
    },
    {
      header: lang.deposits || "Deposits",
      accessorKey: "totalDepositsAmount",
      cell: (row) => row.getValue()?.toFixed(2),
      footer: (info) => {
        const total = info.table.getFilteredRowModel().rows.reduce((sum, row) => {
          return sum + Number(row.original.totalDepositsAmount || 0);
        }, 0);
        return `${lang.Total || "Total"}: ${total.toFixed(2)}`;
      },
    },
    {
      header: lang.withdrawals || "Withdrawals",
      accessorKey: "totalWithdrawalsAmount",
      cell: (row) => row.getValue()?.toFixed(2),
      footer: (info) => {
        const total = info.table.getFilteredRowModel().rows.reduce((sum, row) => {
          return sum + Number(row.original.totalWithdrawalsAmount || 0);
        }, 0);
        return `${lang.Total || "Total"}: ${total.toFixed(2)}`;
      },
    },
    {
      header: lang.contracts_amount || "Contracts Amount",
      accessorKey: "totalContractAmount",
      cell: (row) => row.getValue()?.toFixed(2),
      footer: (info) => {
        const total = info.table.getFilteredRowModel().rows.reduce((sum, row) => {
          return sum + Number(row.original.totalContractAmount || 0);
        }, 0);
        return `${lang.Total || "Total"}: ${total.toFixed(2)}`;
      },
    },
    {
      header: lang["Administration Fee"] || "Administration Fee",
      accessorKey: "totalProfit",
      cell: (row) => row.getValue()?.toFixed(2),
      footer: (info) => {
        const total = info.table.getFilteredRowModel().rows.reduce((sum, row) => {
          return sum + Number(row.original.totalProfit || 0);
        }, 0);
        return `${lang.Total || "Total"}: ${total.toFixed(2)}`;
      },
    },
    {
      header: lang["Expenses"] || "Expenses",
      accessorKey: "totalExpense",
      cell: (row) => row.getValue()?.toFixed(2),
      footer: (info) => {
        const total = info.table.getFilteredRowModel().rows.reduce((sum, row) => {
          return sum + Number(row.original.totalExpense || 0);
        }, 0);
        return `${lang.Total || "Total"}: ${total.toFixed(2)}`;
      },
    },
    {
      header: lang["Purchase Item"] || "Purchase Item",
      accessorKey: "purchaseInvAmount",
      cell: (row) => row.getValue()?.toFixed(2),
      footer: (info) => {
        const total = info.table.getFilteredRowModel().rows.reduce((sum, row) => {
          return sum + Number(row.original.purchaseInvAmount || 0);
        }, 0);
        return `${lang.Total || "Total"}: ${total.toFixed(2)}`;
      },
    },
    {
      header: lang["Sales Item"] || "Sales Item",
      accessorKey: "sellInvAmount",
      cell: (row) => row.getValue()?.toFixed(2),
      footer: (info) => {
        const total = info.table.getFilteredRowModel().rows.reduce((sum, row) => {
          return sum + Number(row.original.sellInvAmount || 0);
        }, 0);
        return `${lang.Total || "Total"}: ${total.toFixed(2)}`;
      },
    },
    {
      header: lang["Investment"] || "Investment",
      accessorKey: "totalInvestment",
      cell: (row) => row.getValue()?.toFixed(2),
      footer: (info) => {
        const total = info.table.getFilteredRowModel().rows.reduce((sum, row) => {
          return sum + Number(row.original.totalInvestment || 0);
        }, 0);
        return `${lang.Total || "Total"}: ${total.toFixed(2)}`;
      },
    },
    {
      header: lang["Actual Income"] || "Actual Income",
      accessorKey: "totalIncome",
      cell: (row) => row.getValue()?.toFixed(2),
      footer: (info) => {
        const total = info.table.getFilteredRowModel().rows.reduce((sum, row) => {
          return sum + Number(row.original.totalIncome || 0);
        }, 0);
        return `${lang.Total || "Total"}: ${total.toFixed(2)}`;
      },
    },
    {
      header: lang["Expected Income"] || "Expected Income",
      accessorKey: "totalExpected",
      cell: (row) => row.getValue()?.toFixed(2),
      footer: (info) => {
        const total = info.table.getFilteredRowModel().rows.reduce((sum, row) => {
          return sum + Number(row.original.totalExpected || 0);
        }, 0);
        return `${lang.Total || "Total"}: ${total.toFixed(2)}`;
      },
    },
    {
      header: lang.date || "Date",
      accessorKey: "date",
      cell: (row) => convertDateFormat(row.getValue()),
    },
  ];

  useEffect(() => {
    setBranchId(
      JSON.parse(JSON.parse(sessionStorage.getItem("aman-admin")).admin).branch_id
    );
  }, []);

  // ✅ investors dropdown
  useEffect(() => {
    axios
      .get(apiKey + "/investor", {
        params: { branch_id: branchId },
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => setInvestorList(res.data.result || []))
      .catch((err) => {
        console.error(err);
        // toast.error("Error loading investors");
      });
  }, [branchId, token]);

  useEffect(() => {
    if (branchId) {
      axios
        .get(`${apiKey}/detailed-operational-report`, {
          params: {
            branchId,
            from,
            to,
            investorId: investor || "",
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          setReports(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [branchId, from, investor, to, token]);

  return (
    <main className="main" id="main">
      <div className="pagetitle">
        <h1>{lang.Reports || "Reports"}</h1>
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 24 24"
              >
                <path d="m21.743 12.331-9-10c-.379-.422-1.107-.422-1.486 0l-9 10a.998.998 0 0 0-.17 1.076c.16.361.518.593.913.593h2v7a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-4h4v4a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-7h2a.998.998 0 0 0 .743-1.669z"></path>
              </svg>
            </li>
            <li className="breadcrumb-item">{lang.Reports || "Reports"}</li>
            <li className="breadcrumb-item active">
              {lang["Detailed Operational Report"] || "Detailed Operational Report"}
            </li>
          </ol>
        </nav>
      </div>
      <section className="section">
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                <div className="mt-3 mb-3">
                  <div className="rr">
                    {lang["Detailed Operational Report"] || "Detailed Operational Report"}
                  </div>
                  <div className="row row justify-content-end gap-2">
                    <>
                      <div className="custom-datepicker">
                        <DatePicker
                          className="form-control w-100"
                          placeholder={lang["from_text"] || "From"}
                          style={{
                            left: "35%",
                            top: "5px",
                            height: "auto",
                          }}
                          containerStyle={{
                            height: "auto",
                          }}
                          onChange={(e) => {
                            const dateObject = new Date(e);
                            setFrom(dateObject);
                          }}
                        />
                      </div>
                      <div className="custom-datepicker">
                        <DatePicker
                          className="form-control w-100"
                          placeholder={lang["to_text"] || "To"}
                          style={{
                            left: "45%",
                            top: "5px",
                            height: "auto",
                          }}
                          containerStyle={{
                            height: "auto",
                          }}
                          onChange={(e) => {
                            const dateObject = new Date(e);
                            setTo(dateObject);
                          }}
                        />
                      </div>
                    </>

                    <select
                      onChange={(e) => setInvestor(e.target.value)}
                      className="btn-export col-3"
                      value={investor}
                    >
                      <option value="">
                        {lang.all_investors || "All Investors"}
                      </option>
                      {investorList.map((inv, index) => (
                        <option key={index} value={inv.id}>
                          {inv.FullName}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div classNames="d-flex mt-3 mb-3">
                  <Table
                    lang={lang}
                    data={reports}
                    columns={columns}
                    footer={true}
                    exportOption={true}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default DetailedOperationalReport;
